import { useEffect, useState } from 'react';
import s from './CourseCard.module.scss';
import { FileManager } from 'components/FileManager/FileManager';
import { useNavigate } from 'react-router-dom';
import { ImageInput } from 'components/ImageInput/ImageInput';
import { clearHTML } from 'utils/clearHTML';
import { useTranslation } from 'react-i18next';

export const CourseCard = ({
    image, 
    title, 
    description, 
    active_price, 
    active_discount, 
    price, 
    discount, 
    form, 
    setForm, 
    type, 
    id,
    storageType, 
    activeLang, 
    modules_length
}: any) => {

    // ### State
    const [storage, setStorage] = useState<boolean>(false)
    const [lessons, setLessons] = useState<string>('')
    const [modules, setModules] = useState<string>('')

    const navigate = useNavigate()
    const {i18n} = useTranslation()
    const dicount_price = active_discount ? price - discount : price

    // ### Effects
    useEffect(()=>{
        const lessons_length = form?.modules?.reduce((acc: number, module: any) => {
            if(module?.lessons?.length){
                acc = acc + module?.lessons?.length
                return acc
            }
            else return acc
        }, 0)
        if(i18n.language === "ru" && lessons_length){
            if(lessons_length > 1 && lessons_length < 5) setLessons(`${lessons_length} занятия`)
            else if(lessons_length > 4) setLessons(`${lessons_length} занятий`)
            else setLessons(`${lessons_length} занятие`)
        }
        if(i18n.language === "en" && lessons_length){
            if(lessons_length > 1) setLessons(`${lessons_length} lessons`)
            else setLessons(`${lessons_length} lesson`)
        }
        
    },[form, i18n.language]);

    useEffect(()=>{
        modules_length = form?.modules?.length
        if(i18n.language === "ru" && modules_length){
            if(modules_length > 1 && modules_length < 5) setModules(`${modules_length} модуля`)
            else if(modules_length > 4) setModules(`${modules_length} модулей`)
            else setModules(`${modules_length} модуль`)
        }
        if(i18n.language === "en" && modules_length){
            if(modules_length > 1) setModules(`${modules_length} modules`)
            else setModules(`${modules_length} module`)
        }
        
    },[form, i18n.language]);

    // ### Functions

    // ### Views
    
    return(
        <div 
            className={`${s.card}`} 
            style={{cursor: type === "click" ? "pointer" : "default"}}
            onClick={()=>{
                type === "click" ? navigate(`/courses/create?id=${id}`) : console.log("click");
            }}
        >
            <div 
                className={s.card_image} 
            >
                <ImageInput 
                    styles={{ borderRadius: "20px" }}
                    disabled={type === "click"}
                    values={image}
                    setValues={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            image: {...prev.image, ...value}
                        }))
                    }}
                    setIsManual={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            image: {...prev.image, isManual: value}
                        }))
                    }}
                    setDefault={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            image: {...prev.image, default_image: value}
                        }))
                    }}
                />
            </div>

            <div className={s.info}>
                <div className={s.info_title}>
                    <h3 className={s.title_text} dangerouslySetInnerHTML={{__html: title}}></h3>
                </div>
                <div style={{flex: "1 0 auto"}}>
                    <p className={s.info_description} dangerouslySetInnerHTML={{__html: description}}></p>
                </div>

                {
                    active_price ? 
                    <div className={s.info_price}>
                        <div className={s.price}>
                            {
                                active_discount ?
                                <p className={s.price_discount}>{price} ₴</p>
                                :null
                            }
                            <p className={s.price_value}>{dicount_price} ₴</p>
                        </div>
                        <p className={s.count}>{`${modules}, ${lessons}`}</p>
                    </div> : null
                }

                <div className={s.button_wrapper}>
                    <div className={s.button}>{form?.active_card_button_text ? clearHTML(form?.card_button_text?.[activeLang]) : active_price ? "Купить" : "Получить бесплатно"}</div>
                </div>
            </div>

            {
                storage ? 
                <FileManager 
                    isModal={true}
                    type={storageType}
                    setIsOpenStorage={() => setStorage(false)}
                    setFile={(link) =>  setForm((prev: any) => ({...prev, image: link}))}
                /> : null
            }
        </div>
    )
}